import { render, staticRenderFns } from "./Configure3DModelScaleSlider.vue?vue&type=template&id=72b318a9&scoped=true"
import script from "./Configure3DModelScaleSlider.vue?vue&type=script&lang=js"
export * from "./Configure3DModelScaleSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b318a9",
  null
  
)

export default component.exports